import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Token CSS vars first so globals.css (and Tailwind's base) can consume them.
import "./styles/tokens.generated.css";
import "./styles/globals.css";

// Enable Strict Mode in development for better error detection
ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
